export default __webpack_public_path__ + "static/media/language.75c9d70d.svg";